module.exports = __webpack_public_path__ + "media/scene12_speaker.408cba14.mp3";